<template>
  <div
    v-html="$t('state.main_features-html')"
  />
</template>
